export default "__VITE_ASSET__yV2RaVHc__"